document.addEventListener("DOMContentLoaded", function () {

  var wishlistButtons = document.querySelectorAll(".coll_prdct .swym-add-to-wishlist-view-product");
  wishlistButtons.forEach(function (btn) {
      btn.addEventListener("click", function (event) {
            updateWishlistText();
      });
   });

 //product page grid click
  var observer = new MutationObserver(function () {
    var wishlistBtn = document.querySelector(".swym-add-to-wishlist");
    if (wishlistBtn && !wishlistBtn.dataset.listenerAdded) {
        wishlistBtn.dataset.listenerAdded = "true";
        wishlistBtn.addEventListener("click", function () {
            updateWishlistText();
        });
        observer.disconnect(); 
    }
});

  observer.observe(document.body, { childList: true, subtree: true });
  
  function updateWishlistText() {
    const interval = setInterval(() => {
        const container = document.querySelector('.swym-wishlist-notifications-container');
        if (!container) return; 
        const emphasisSpans = container.querySelectorAll('.swym-emphasis');
        if (emphasisSpans.length >= 2) {
            const secondEmphasis = emphasisSpans[1]; 
            if (secondEmphasis.textContent.trim() === "1 list") {
                secondEmphasis.textContent = "Wishlist"; 
                clearInterval(interval);
            }
        }
    }, 100); 
  }
  
});


setInterval(function() {
    let elements = document.querySelectorAll('.swym-emphasis');
    if (elements.length > 0) {
        elements[elements.length - 1].textContent = 'Wishlist';
    }
}, 100);



